export const socialIconList = [
  {
    name: 'twitter',
    prefix: 'fab', // fab prefix for brands, fas for solid icons
    link: 'https://twitter.com/',
  },
  {
    name: 'github',
    prefix: 'fab',
    link: 'https://github.com/knochenmark/gatsby-starter-level-2',
  },
  {
    name: 'codepen',
    prefix: 'fab',
    link: 'https://codepen.io/',
  },
  // Add further social links with the icon of choice and link here
  // check https://fontawesome.com/icons?d=gallery&s=brands for other brand icons
];
